import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/banner-baogia.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/delivery/ShippingRequestDocumentWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/delivery/ShippingRequestMainTable.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/ToastProvider.js");
